<section class="content-header">

    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-sm-6">
                <h1 class="m-0 text-dark">Awareness Programs</h1>
            </div>

        </div>
        <!-- /.row -->
    </div>
    <!-- /.container-fluid -->
</section>
<!-- /.content-header -->
<section class="content">
    <!-- Default box -->
    <div class="container-fluid">

                <div class="card">
                    <div class="card-header">
                        <h3 class="card-title">Add New Awareness Program</h3>

                    </div>
                    <div class="card-body">
                        <form [formGroup]="programAddForm" (ngSubmit)="updateInsertData()">
                            <!-- <div class="form-group"> -->

                            <h5 *ngIf="success">Your form is valid!</h5>
                            <div class="form-group">
                                <label style="font-weight:bold">
                                    Program Title:<span style="color:red;">*</span>
                                    <input type="text" style="width:600px" formControlName="programTitle"
                                        class="form-control" [ngClass]="{ 'is-invalid': submitted && f.programTitle.errors }">
                                    <div *ngIf="submitted && f.programTitle.errors" class="invalid-feedback">
                                        <div *ngIf="f.programTitle.errors.required">Title is
                                            required</div>
                                    </div>
                                </label>
                            </div>
                            <div class="form-group">
                                <label style="font-weight:bold">
                                    Program Date:<span style="color:red;">*</span>
                                    <input formControlName="programDate" class="form-control"  type="date" dateformat="d M y" [ngClass]="{ 'is-invalid': submitted && f.programDate.errors }">
                                    <div *ngIf="submitted && f.programDate.errors" class="invalid-feedback">
                                        <div *ngIf="f.programDate.errors.required">Program Date is required</div>
                                    </div>
                                </label>
                            </div>
                            <div class="form-group">
                                <label style="font-weight:bold">
                                    Description:<span style="color:red;">*</span>
                                    <textarea type="text" style="width:600px" maxlength="1000" formControlName="programDesc"
                                        class="form-control"  [ngClass]="{ 'is-invalid': submitted && f.programDesc.errors && f.programDesc.errors?.maxlength }">
                                    </textarea>

                                    <div *ngIf="submitted && f.programDesc.errors" class="invalid-feedback">
                                        <div *ngIf="f.programDesc.errors.required">Description is
                                            required
                                        </div>
                                        
                                        <span style="color: red;" *ngIf="submitted && (f.programDesc.errors?.maxlength)">
                                            Description Range=1000 Characters
                                          </span> 
                                    </div>

                                    
                                </label>
                            </div>
                            <div class="form-group">
                                <label style="font-weight:bold">
                                    No. of Trainees:<span style="color:red;">*</span>
                                    <input type="text" style="width:600px" formControlName="noOfTrainees" (keypress)="($event.charCode >= 48 && $event.charCode < 58)"
                                        class="form-control" [ngClass]="{ 'is-invalid': submitted && f.noOfTrainees.errors }">
                                    <div *ngIf="submitted && f.noOfTrainees.errors" class="invalid-feedback">
                                        <div *ngIf="f.noOfTrainees.errors.required">No. of
                                            Trainees is required</div>
                                        <div *ngIf="f.noOfTrainees.errors.pattern">Enter only
                                            number.</div>
                                    </div>
                                </label>
                            </div>
                            <div class="form-group">
                                <label style="font-weight:bold">
                                    Trainer name:<span style="color:red;">*</span>
                                    <input type="text" style="width:600px" formControlName="trainerName"
                                        class="form-control" [ngClass]="{ 'is-invalid': submitted && f.trainerName.errors }">
                                    <div *ngIf="submitted && f.trainerName.errors" class="invalid-feedback">
                                        <div *ngIf="f.trainerName.errors.required">Trainer name is
                                            required</div>
                                    </div>
                                </label>
                            </div>
                            <div class="form-group">
                                <label>
                                    District:<span style="color:red;">*</span>
                                   <select [(ngModel)]="selectedDistrict" style="width:600px" formControlName="districtCode" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.districtCode.errors }">
                                        <option [ngValue]="null" selected disabled>Select District</option>
                                        <option *ngFor="let district of districtRecord" [ngValue]="district.districtCode">
                                            {{district.districtName}}</option>
                                    </select>
                                    <div *ngIf="submitted && f.districtCode.errors" class="invalid-feedback">
                                        <div *ngIf="f.districtCode.errors.required">District is required</div>
                                    </div>
                                </label>
                            </div>
                            <div class="form-group">
                                <label style="font-weight:bold">
                                    GPS Location:<span style="color:red;">*</span>
                                    <input type="text" style="width:600px" formControlName="gpsLocation"
                                        class="form-control" [ngClass]="{ 'is-invalid': submitted && f.gpsLocation.errors }">
                                    <div *ngIf="submitted && f.gpsLocation.errors" class="invalid-feedback">
                                        <div *ngIf="f.gpsLocation.errors.required">GPS Location is
                                            required</div>
                                    </div>
                                </label>
                            </div>
                            <div class="form-group">
                                <label style="font-weight:bold">
                                    Training Venue:<span style="color:red;">*</span>
                                    <input type="text" style="width:600px" formControlName="venue" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.venue.errors }">
                                    <div *ngIf="submitted && f.venue.errors" class="invalid-feedback">
                                        <div *ngIf="f.venue.errors.required">Venue is required
                                        </div>
                                    </div>
                                </label>
                            </div>
                            <div class="form-group">
                                <label style="font-weight:bold">
                                    Remark:
                                    <textarea formControlName="remarks" style="width:600px"
                                        class="form-control"></textarea>
                                    <!-- <div *ngIf="submitted && artAddForm.controls.remarks.errors" class="error">
                            <div *ngIf="artAddForm.controls.remarks.errors.required">Title is required</div>
                        </div> -->
                                </label>
                            </div>


                            <div class="form-group">
                                <!-- <label>Upload Report:</label>
                    <input type="file" name="doc" (change)="onFileSelect($event)" class="form-control" /> -->
                                <div class="row">
                                    <div class="col-4">
                                        <label class="btn btn-default p-0">
                                            <input type="file" multiple (change)="onFileSelect($event)" />
                                        </label>
                                    </div>
                                    <div class="col-1">
                                       <!--  <input type="submit" value="Upload" class="btn btn-success btn-sm"
                                            [disabled]="!fileName"> -->
                                            <input type="button" (click)="onSubmit()" value="Upload" class="btn btn-success btn-sm" [disabled]="!fileName">
                                    </div>
                                    <div class="col-7">
                                        <div style="font-weight:bold;margin-top: -10px;">Max file size:3 Mb<br/>
                                            Type(jpeg,jpg,png,pdf)</div>
                                    </div>
                                </div>
                                <div class="card mt-3" *ngIf="success==true">
                                    <div class="card-header">List of Files</div>
                                    <!-- <ul class="list-group list-group-flush" *ngFor="let file of fileInfos; let i=index">
                            <li class="list-group-item">
                                <a href="{{file.filePath}}">{{file.filePath}}</a>
                            </li>
                        </ul> -->
                                    <table class="table table-hover">
                                        <thead>
                                            <tr>
                                                <td style="font-weight:bold">Sr. No.</td>
                                                <td style="font-weight:bold">File Name</td>
                                                <td style="font-weight:bold">Actions</td>
                                                <!-- <td>Created On</td> -->
                                                <!-- <td>Source</td> -->
                                                <!-- <td colspan="2">Actions</td> -->
                                            </tr>
                                        </thead>

                                        <tbody>
                                            <tr
                                                *ngFor="let file of fileInfos | paginate : {itemsPerPage: 10, currentPage : p}; let i=index">
                                                <td>{{ itemsPerPage * (p - 1) + i + 1 }}</td>
                                                <td>{{file.filename}}</td>
                                                <td>
                                                    <input type="button" (click)="deleteRow(file)" value="Delete"
                                                        class="btn btn-danger" [disabled]="!fileName">
                                                </td>
                                                <!-- <td>{{ review.source }}</td> -->
                                                <!-- <td><a [routerLink]="" class="btn btn-primary">Edit</a></td>
                                    <td><a href="#" class="btn btn-danger">Delete</a></td> -->
                                                <!-- <td><a href="#" (click)="publishArticle(article._id, article.published)" class="btn btn-danger">{{showPublishText(article.published)}}</a></td> -->
                                            </tr>
                                        </tbody>
                                    </table>
                                    <!-- <pagination-controls (pageChange)="p = $event" class="float-right">
                                    </pagination-controls> -->
                                </div>
                            </div>


                            <br />

                            <div class="form-group">
                                <!-- <input type="button" (click)="updateInsertData()" value="Submit"
                                    class="btn btn-primary"> -->
                                    <input type="submit"  value="Submit" class="btn btn-primary">
                                </div>
                            <!-- <div *ngIf="submitted">
                                <h3>Record saved successfully!</h3>
                            </div> -->
                            <!-- </div> -->
                        </form>

                    </div>
                    <div class="card-footer"></div>
                </div>
           
        
    </div>
</section>

<!-- 
      <div *ngIf="submitted" class="results">
        <strong>Question:</strong> 
        <span>{{ quizAddForm.controls.question.value }}</span>
    
        <strong>Answer:</strong> 
        <span>{{ quizAddForm.controls.answer.value }}</span>
      </div> -->


<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
    <p style="color: white">Please Wait. </p>
</ngx-spinner>